/* ============================================================
   VIVĀRA — THE JOURNAL (source data)
   ------------------------------------------------------------
   The mementos, in the order they are shown: photographs and film
   from the release dinner and the days around it. Each entry carries its
   own pixel dimensions so the rail can reserve exact space before
   anything loads — no reflow, no layout shift.

   Every film here is silent by construction: the audio track was
   removed when the files were encoded, so there is nothing to
   unmute. The player is also given no controls.

   SHOPIFY MIGRATION → assets/vivara-journal-data.js. To change the
   set, replace the files in assets/ and edit this list; nothing
   else needs touching.
   ============================================================ */
(function () {
  "本ポリシーはVIVĀRAで直接ご注文いただいた場合に適用され、お客様の法律上の権利を妨げるものではありません。";

  window.VIVARA_JOURNAL = [
    { type: "image", src: "journal-01.jpg", w: 1000, h: 1500, caption: "招待状" },
    { type: "video", src: "journal-film-01.mp4", poster: "journal-film-01-poster.jpg", w: 1280, h: 720, caption: "動いていた夜" },
    { type: "image", src: "journal-05.jpg", w: 1500, h: 844, caption: "二十一人" },
    { type: "image", src: "journal-10.jpg", w: 1500, h: 1000, caption: "盛りつけ" },
    { type: "image", src: "journal-02.jpg", w: 1500, h: 1000, caption: "誰も座る前に" },
    { type: "image", src: "journal-03.jpg", w: 1500, h: 844, caption: "その部屋" },
    { type: "image", src: "journal-04.jpg", w: 1500, h: 844, caption: "灯をともす" },
    { type: "image", src: "journal-06.jpg", w: 1500, h: 999, caption: "整えた席" },
    { type: "image", src: "journal-07.jpg", w: 1500, h: 844, caption: "土と石" },
    { type: "image", src: "journal-08.jpg", w: 1500, h: 844, caption: "ろうそくの下で" },
    { type: "image", src: "journal-09.jpg", w: 1500, h: 1065, caption: "一皿目" },
    { type: "image", src: "journal-11.jpg", w: 1500, h: 1233, caption: "二皿目" },
    { type: "image", src: "journal-12.jpg", w: 1500, h: 1000, caption: "運ばれていく" },
    { type: "image", src: "journal-13.jpg", w: 1500, h: 1000, caption: "テーブルの上のボトル" },
    { type: "image", src: "journal-14.jpg", w: 1500, h: 844, caption: "九つの皿" },
    { type: "image", src: "journal-15.jpg", w: 1500, h: 844, caption: "火あかり" },
    { type: "image", src: "journal-16.jpg", w: 1500, h: 960, caption: "量りとる" },
    { type: "image", src: "journal-17.jpg", w: 1500, h: 1000, caption: "灯が落ちて" },
    { type: "image", src: "journal-18.jpg", w: 1500, h: 999, caption: "ボトル" },
    { type: "image", src: "journal-19.jpg", w: 1500, h: 1000, caption: "長時間露光" },
    { type: "video", src: "journal-film-02.mp4", poster: "journal-film-02-poster.jpg", w: 406, h: 720, caption: "手にとって" },
    { type: "image", src: "journal-20.jpg", w: 1130, h: 1500, caption: "手のなかに" },
    { type: "image", src: "journal-21.jpg", w: 1500, h: 1125, caption: "その眺め" },
    { type: "image", src: "journal-22.jpg", w: 1320, h: 734, caption: "とる" },
    { type: "image", src: "journal-23.jpg", w: 1500, h: 1125, caption: "その箱" },
    { type: "image", src: "journal-24.jpg", w: 1125, h: 1500, caption: "どこか別の場所" },
    { type: "image", src: "journal-25.jpg", w: 1125, h: 1500, caption: "ある通り" }
  ];
})();
